import { faDownload, faFilePdf, faFileImage, faFileExcel, faFileWord, faFile, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React,{ useState } from "react";
import { useTranslation } from "react-i18next";
import mainAxios from "../../../services/mainAxios";
import DocumentPreview from "../../DocumentPreview";
import PrimeTable from "../../PrimeTable/PrimeTable";
import { bankStatusStyle, generateStatusStyle } from "../OpenBankingUtils";
import moment from "moment";

const PayrollHistory = ({  payroll,fromPayroll}) => {
  const [loadingDocument,setLoadingDocument]=useState(false);
  const [filePreview,setFilePreview]=useState(null);
  const atachmentsRef = React.useRef()
  const { t } = useTranslation("translations");

  const payrollApprovalList=payroll?.salaryOrderHistorics ?? []


const columns = [
  {
    header: "Date",
    field: "recordDate",
    sortable: true,
    style: { minWidth: "180px", maxWidth: "200px" },
    body: (row) => moment(row.recordDate).format("DD/MM/YYYY HH:mm")
  },
  {
    header: "Action",
    field: "salaryAction",
    style: { minWidth: "140px", maxWidth: "160px" },
  },
  {
    header: "Status",
    field: "salaryStatus",
    sortable: true,
    style: { minWidth: "150px", maxWidth: "180px" },
    body: (row) => {
      const status = generateStatusStyle(row.salaryStatus?.name, t)
      return (
        <small className={`badge badge-${status.badgeClass}`}>
          {status?.status ?? ""}
        </small>
      )
    }
  },
  {
    header: "Bank Status",
    field: "bankStatus",
    body: (row) => {
      const bankStatus = bankStatusStyle(row?.bankStatus, t)
      return (
        <small className={`badge badge-${bankStatus.badgeClass}`}>
          {bankStatus?.status ?? ""}
        </small>
      )
    },
    sortable: true,
    style: { minWidth: "150px", maxWidth: "180px" },
  },
  {
    header: "Comment",
    field: "comment",
    sortable: true,
    style: { minWidth: "150px", maxWidth: "180px" },
  },
  {
    header: t("logs.user"),
    field: "recordUser",
    sortable: true,
    style: { minWidth: "150px", maxWidth: "180px" },
    body: (row) => row?.recordUser ?? "",
  },
];
  

  const fetchDocument = (e, id, name, type, download = false) => {
    e.preventDefault()
    setLoadingDocument(true)
    mainAxios
      .post("endpoint/v2/getInternalAtachementByte", {
        value: id
      })
      .then((res) => {
        setLoadingDocument(false)
        if (res?.data?.status) {
          if (!download) {
            setFilePreview({
              name,
              type,
              base64: res.data.content[0]
            })
            setTimeout(() => {
              atachmentsRef.current.classList.toggle('open')
            }, 250)
          } else {
            const linkSource = `data:application/pdf;base64,${res.data.content[0]}`;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = name;
            downloadLink.click();
          }
        }
      })
      .catch((_) => {
        setLoadingDocument(false);
      })
  }


  const thumbs = (payrollApprovalList) => {

    const placeholder = (type) => {
      if (type == "pdf") {
        return faFilePdf;
      } else if (type == "jpg" || type == "jpeg" || type == "png") {
        return faFileImage;
      } else if (type == "xlsx") {
        return faFileExcel;
      } else if (type == "docx") {
        return faFileWord;
      } else {
        return faFile;
      }
    }

    if (payrollApprovalList?.payrollHistoricAttachments) return payrollApprovalList.payrollHistoricAttachments.map(({ id, name, type }, index) => {

      return (
        <div key={index} className="atachment d-flex flex-column justify-content-center align-items-center">
          <FontAwesomeIcon color="#5c656d" size="3x" icon={placeholder(type)} />
          <div className="atachment-name mx-1 text-center">
            {name}
          </div>
          <div className="d-flex mx-1 mt-3">
            <button
              className="attachment__actions--button bg-primary"
              onClick={(e) => { if (!loadingDocument) fetchDocument(e, id, name, type) }}
            >
              <FontAwesomeIcon icon={faEye} />
            </button>
            <button
              className="attachment__actions--button bg-info"
              onClick={(e) => { if (!loadingDocument) fetchDocument(e, id, name, type, true) }}>
              <FontAwesomeIcon icon={faDownload} />
            </button>
          </div>
        </div>
      )
    })
    return <></>
  }

  const closePreview = () => {
    setTimeout(() => {
      setFilePreview(null)
    }, 150);
    atachmentsRef.current.classList.toggle('open')
  }

  return (
    <div style={{height:"100%"}}>
      <PrimeTable
        columns={columns}
        value={payrollApprovalList ?? []}
        simpleTable={true}
        showSelectColumns={false}
        clearFilters={false}
        searchableKeys={["recordDate", "recordUser", "workflowStatus", "comment"]}
        showGlobalSearch={true}
        defaultSortCriteria={{ field: "recordDate", direction: "DESC" }}
      />
    </div>
  );
};

export default PayrollHistory;